import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GetUtils, SortUtil } from '@iot-platform/iot-platform-utils';
import { UserAccount } from '@iot-platform/models/common';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'oyan-ui-user-preferences-form-dialog',
  templateUrl: './user-preferences-form-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class UserPreferencesFormDialogComponent implements OnInit {
  form: UntypedFormGroup;
  countries$: Observable<{ key: string; value: string }[]>;
  public data: { user: UserAccount } = inject(MAT_DIALOG_DATA);
  private readonly dialogRef: MatDialogRef<UserPreferencesFormDialogComponent> = inject(MatDialogRef<UserPreferencesFormDialogComponent>);
  private readonly translateService: TranslateService = inject(TranslateService);
  availableLanguages: string[] = [...this.translateService.getLangs()];

  constructor() {
    this.countries$ = this.translateService.get('IOT_DICTIONARY.COUNTRIES').pipe(
      map((countries: { [key: string]: string }) =>
        Object.keys(countries)
          .map((key: string) => ({ key, value: countries[key] }))
          .sort(SortUtil.sortByProperty('value'))
      )
    );
  }

  get appLanguage(): AbstractControl {
    return this.form.get('appLanguage');
  }

  get addressCountry(): AbstractControl {
    return this.form.get('addressCountry');
  }

  ngOnInit() {
    this.form = new UntypedFormGroup({
      appLanguage: new UntypedFormControl(GetUtils.get(this.data, 'user.preferences.appLanguage', 'en'), [Validators.required]),
      addressCountry: new UntypedFormControl(GetUtils.get(this.data, 'user.addressCountry', ''))
    });
  }

  save(): void {
    this.dialogRef.close({
      addressCountry: this.addressCountry.value,
      preferences: {
        ...this.data.user.preferences,
        appLanguage: this.appLanguage.value
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
